import React from 'react';
import { Clock } from 'lucide-react';
import { cn } from '../../utils/cn';
import { ReferenceWithAnswers } from '../../api/references';
import { useLanguage } from '../../contexts/LanguageContext';

interface ReferenceTableHeaderProps {
  references: ReferenceWithAnswers[];
}

const ReferenceTableHeader = ({ references }: ReferenceTableHeaderProps) => {
  const { t } = useLanguage();
  // Count references that haven't been filled out yet
  const pendingReferences = references.filter(ref => 
    !ref.filled_form_at || ref.answers.length === 0
  );

  return (
    <div className="px-6 py-4 border-b">
      <div className="flex flex-col gap-1">
        <h3 className="text-sm font-semibold text-gray-900">{t('candidates.referenceModals.referencesTable.title')}</h3>
        {pendingReferences.length > 0 && (
          <div className={cn(
            "flex items-center gap-1.5",
            "text-xs text-amber-600"
          )}>
            <Clock className="w-3.5 h-3.5" />
            <span>
              {t('candidates.referenceModals.referencesTable.pendingResponses', {
                count: pendingReferences.length.toString(),
                responseText: pendingReferences.length === 1 
                  ? t('candidates.referenceModals.referencesTable.response')
                  : t('candidates.referenceModals.referencesTable.responses')
              })}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default ReferenceTableHeader;